import { render, staticRenderFns } from "./Controls2.vue?vue&type=template&id=95e7965e&scoped=true&"
import script from "./Controls2.vue?vue&type=script&lang=js&"
export * from "./Controls2.vue?vue&type=script&lang=js&"
import style0 from "./Controls2.vue?vue&type=style&index=0&id=95e7965e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e7965e",
  null
  
)

export default component.exports